<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxServiceType)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty" >
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.name.nullable}">{{ validation.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="name" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.name"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.description.nullable}">{{ validation.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="description" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.description"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane text-center ui-helper-clearfix">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{dialogBoxServiceType.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'serviceTypeList.serviceType' |translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/service-type/serviceTypeForm.html